import i18n from '@/i18n'
export default {
  columns: (vm) => {
    return [{
      title: i18n.t('user.columns.016995-0'),
      type: 'index',
      width: 120,
      align: 'center',
      indexMethod: (row) => {
        if (vm.page) {
          return (vm.page.page - 1) * vm.page.size + row._index + 1;
        } else {
          return row._index + 1;
        }
      }
    },{
      title: i18n.t('user.columns.016995-1'),
      key: 'RoomName',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-2'),
      key: 'OrganizationName',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-3'),
      key: 'OwnerPhone',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-4'),
      key: 'RoomType',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.RoomType === 1 ? i18n.t('user.columns.016995-5') : params.row.RoomType === 2 ? i18n.t('user.columns.016995-6') : '-');
      }
    },
    {
      title: i18n.t('user.columns.016995-7'),
      key: 'QiTiBaoJingQiCount',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-8'),
      key: 'RanQiDcfCount',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-9'),
      key: 'RunStatus',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.RunStatus == 0 ? i18n.t('user.columns.016995-10') : params.row.RunStatus == 1 ? i18n.t('user.columns.016995-11') : '-');
      }
    },
    {
      title: i18n.t('user.columns.016995-12'),
      key: 'UserLimitYear',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-13'),
      key: 'AreaManager',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-14'),
      key: 'AreaManagerPhone',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('user.columns.016995-15'),
      key: 'YearExamState',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.YearExamState == 1 ? i18n.t('user.columns.016995-16') : params.row.YearExamState == 2 ? i18n.t('user.columns.016995-17') : '-');
      }
    },
    {
      title: i18n.t('user.columns.016995-18'),
      slot: 'Jdzsyxq',
      resizable: true,
      minWidth: 220,
      align: 'center',
      render: (h, params) => {
        return h('div', [
          h('span', vm.formDateNew(params.row.Jdzsyxq_start) + '-'),
          h('span', vm.formDateNew(params.row.Jdzsyxq_end)),
        ])
      }
    },
    {
      title: i18n.t('user.columns.016995-19'),
      key: 'action',
      width: 160,
      align: 'center',
      fixed: 'right',
      render: (h, params) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'success',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.handleUser('device', params.row)
              }
            }
          }, i18n.t('user.columns.016995-20')),
          // h('Button', {
          //   props: {
          //     type: 'info',
          //     size: 'small'
          //   },
          //   style: {
          //     marginRight: '5px'
          //   },
          //   on: {
          //     click: () => {
          //       vm.handleUser('edit', params.row)
          //     }
          //   }
          // }, '编辑'),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: () => {
                vm.$Modal.confirm({
                  title: i18n.t('user.columns.016995-21'),
                  content: `<p>是否删除"${params.row.RoomName}"</p>`,
                  onOk: () => {
                    vm.removeClick(params.row)
                  },
                  onCancel: () => { }
                });

              }
            }
          }, i18n.t('user.columns.016995-23'))
        ]);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/user/columns.js